import styled from "styled-components";

import { poppins_body_md_medium } from "../font/poppins/body";
import { poppins_heading_lg } from "../font/poppins/heading";

export const Content = styled.div`
  max-width: 60rem;
  width: 48rem;
  position: relative;
  padding: var(--Spacing-20, 2rem);
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-12, 1.2rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.16), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  background: var(--Color-Common-Bg-Primary, #fff);
  margin: 0 auto;
`;

export const Title = styled.div`
  color: var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
  ${poppins_heading_lg}
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: var(--Border-Radius-Circle, 99999.9px);
  background: transparent;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Secondary-Hovered, #f0f2f4);
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
`;

export const Input = styled.input<{
  $inputAlign?: "left" | "center" | "right";
}>`
  width: 100%;
  height: 4rem;
  padding: var(--Spacing-8, 0.8rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);
  color: var(--Color-Common-Text-Primary, #2a2f37);
  text-align: ${({ $inputAlign }) => $inputAlign ?? "left"};
  ${poppins_body_md_medium}
  outline: none;

  &::placeholder {
    color: var(--Color-Common-Text-Tertiary, #96a1b0);
  }

  &:focus {
    border-color: var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 0.8rem;
  gap: 0.8rem;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  display: flex;
  width: 50%;
  height: var(--Size-Btn-Placeholder-Md, 4rem);
  max-height: var(--Size-Btn-Lg, 4.8rem);
  padding: var(--Spacing-Btn-8, 0.8rem) var(--Spacing-Btn-16, 1.6rem);
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-Btn-4, 0.4rem);
  border-radius: var(--Border-Radius-4, 0.4rem);
  background: var(--Color-Common-Bg-Interactive-Primary, #1baefe);
  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  text-align: center;
  ${poppins_body_md_medium}

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
      0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  }

  &:active {
    background: var(--Color-Common-Bg-Interactive-Primary-Pressed, #017abc);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08) inset,
      0px 0px 2px 0px rgba(0, 0, 0, 0.06) inset;
  }
`;
